import { Flex, GapSize } from "@/components/atoms/flex";
import { AttachmentsViewProps } from "./types";
import { Attachment } from "@/components/atoms/attachment";
import { FilePreview } from "../filePreview";
import { fileToImageSrc, isImage } from "@/common/helpers";
import { useStyle } from "./style";
import { Divider, Text } from "@fluentui/react-components";
import { useIntl } from "react-intl";

export const AttachmentsView = (props: AttachmentsViewProps) => {
	const { data, onAttachmentRemove, isDragActive, isRemoveAllowed } = props;
	const classes = useStyle();
	const intl = useIntl();

	 const addedAttachments = data.attachments.filter((x) => !x.contentId); //not inline

	const attachmentsView =
		!!addedAttachments?.length || isDragActive ? (
			<>
				<div style={{ position: "relative", minHeight: "66px" }}>
					<Divider />
					<Flex
						wrap="wrap"
						gap={GapSize.Small}
						className={classes.attachmentsContainer}
					>
						{addedAttachments.map((x) => (
							<FilePreview
								key={`${x.id}-${x.file.name}`}
								queryKey={x.file.name}
								queryFn={() => fileToImageSrc(x.file)}
								name={x.file.name}
								children={(preview: () => void) => (
									<Attachment
										name={x.file.name}
										size={x.file.size}
										type={x.file.type}
										uploadStatus={x.uploadStatus}
										onPreview={isImage(x.file.type) ? preview : undefined}
										onRemove={
											isRemoveAllowed ? () => onAttachmentRemove(x) : undefined
										}
									/>
								)}
							/>
						))}
					</Flex>
					{isDragActive && (
						<div className={classes.draggedOverContainer}>
							<Text>
								{intl.formatMessage({
									id: "Interaction.EmailEditor.DropFiles",
								})}
							</Text>
						</div>
					)}
				</div>
			</>
		) : undefined;

	return attachmentsView;
};
